module.exports = __webpack_public_path__ + "img/BA3.f8e23f9c.png";